import _objectSpread from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
var __default__ = {
  data: function data() {
    return {
      barData: [],
      barChartRaceData: [],
      allBarChartRaceData: [],
      pieChartData: [],
      currentObj: {},
      current: "",
      currentDate: "",
      updatedAt: "",
      activeGrade: "all",
      schools: [],
      allSchools: [],
      allSchoolsTable: [],
      totalStudents: 0,
      totalAbsence: 0,
      totalInfection: 0,
      monthList: [],
      barMonth: "current",
      selectedDay: moment().format("YYYY-MM-DD"),
      // 当日の日付
      intervalId: undefined
    };
  },
  head: {
    title: {
      inner: "ダッシュボード"
    },
    meta: []
  },
  watch: {
    isAuthenticated: {
      handler: function handler(v) {
        var _this = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var data, absenceBySchool;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!v) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return Promise.all([getData("attendance_summary?dashboard=1&date=".concat(_this.selectedDay)), getData("attendance_summary?pieChart=1&date=".concat(_this.selectedDay, "&school_type=all")), getData("attendance_summary?bar=1&to=".concat(_this.selectedDay)), getData("attendance_summary?barChartRace=1&date=".concat(_this.selectedDay))]);
              case 1:
                data = _context.v;
                absenceBySchool = data[0].items;
                _this.pieChartData = data[1].items;
                _this.barData = data[2].items;
                _this.barChartRaceData = _this.allBarChartRaceData = _this.optimizeBarChartRace(data[3].items);
                _this.schools = _this.allSchools = _this.mergeSchoolAbsence(absenceBySchool);
                _this.getTotal();
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }))();
      },
      immediate: true
    }
  },
  created: function created() {
    moment.locale("ja");
    this.currentObj = moment(); // 当日の日付
    this.current = this.currentObj.format("YYYY年MM月DD日 HH時mm分");
    this.currentDate = this.currentObj.format("YYYY年MM月DD日");
    this.updatedAt = this.currentObj.format("HH時mm分");
    this.createMonthList();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.intervalId = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var data, absenceBySchool;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!_this2.$auth.isAuthenticated) {
              _context2.n = 2;
              break;
            }
            _context2.n = 1;
            return Promise.all([getData("attendance_summary?dashboard=1&date=".concat(_this2.selectedDay)), getData("attendance_summary?pieChart=1&date=".concat(_this2.selectedDay, "&school_type=").concat(_this2.activeGrade)), _this2.barMonth === "current" ? getData("attendance_summary?bar=1&to=".concat(_this2.selectedDay)) : getData("attendance_summary?bar=1&".concat(_this2.barMonth)), getData("attendance_summary?barChartRace=1&date=".concat(_this2.selectedDay))]);
          case 1:
            data = _context2.v;
            absenceBySchool = data[0].items;
            _this2.pieChartData = data[1].items;
            _this2.barData = data[2].items;
            _this2.allBarChartRaceData = _this2.optimizeBarChartRace(data[3].items);
            _this2.allSchools = _this2.mergeSchoolAbsence(absenceBySchool);
            if (_this2.activeGrade === "all") {
              _this2.schools = _this2.allSchools.map(function (v) {
                return v;
              });
              _this2.barChartRaceData = _this2.allBarChartRaceData;
            } else {
              _this2.schools = _this2.allSchools.filter(function (v) {
                return v.type === _this2.activeGrade;
              });
              _this2.barChartRaceData = _this2.allBarChartRaceData.filter(function (v) {
                return v.type === _this2.activeGrade;
              });
            }
            _this2.getTotal();
            _this2.currentObj = moment(); // 当日の日付
            _this2.current = _this2.currentObj.format("YYYY年MM月DD日 HH時mm分");
            _this2.currentDate = _this2.currentObj.format("YYYY年MM月DD日");
            _this2.updatedAt = _this2.currentObj.format("HH時mm分");
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    })), 600000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    setActiveGrade: function setActiveGrade(grade) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.activeGrade = grade;
              if (!_this3.$auth.isAuthenticated) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return getData("attendance_summary?pieChart=1&date=".concat(_this3.selectedDay, "&school_type=").concat(_this3.activeGrade));
            case 1:
              data = _context3.v;
              _this3.pieChartData = data.items;
              if (_this3.activeGrade === "all") {
                _this3.schools = _this3.allSchools;
                _this3.barChartRaceData = _this3.allBarChartRaceData;
              } else {
                _this3.schools = _this3.allSchools.filter(function (v) {
                  return v.type === _this3.activeGrade;
                });
                _this3.barChartRaceData = _this3.allBarChartRaceData.filter(function (v) {
                  return v.type === _this3.activeGrade;
                });
              }
              _this3.getTotal();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getTotal: function getTotal() {
      var _this4 = this;
      this.totalAbsence = 0;
      this.totalInfection = 0;
      var verticalTotal = this.schools.filter(function (v) {
        return v.student_count !== 0;
      }).reduce(function (sum, v) {
        sum["student_count"] += v.student_count;
        Object.keys(v["absence"]).forEach(function (key) {
          if (key !== "date" && key !== "school_id") {
            if (key in sum["absence"]) {
              sum["absence"][key] += v["absence"][key];
            } else {
              sum["absence"][key] = v["absence"][key];
            }
          }
        });
        _this4.totalAbsence += v.pointsMap.absencePointsMap;
        _this4.totalInfection += v.pointsMap.infection;
        return sum;
      }, {
        id: 0,
        name: "全校",
        student_count: 0,
        absence: {}
      });
      this.totalStudents = verticalTotal.student_count;
      this.allSchoolsTable = [verticalTotal].concat(_toConsumableArray(this.schools));
    },
    createMonthList: function createMonthList() {
      var currentStartDay = this.currentObj.clone().startOf("month");
      this.monthList = [{
        month: this.currentObj.month() + 1,
        period: "from=".concat(currentStartDay.format("YYYY-MM-DD"), "&to=").concat(this.currentObj.format("YYYY-MM-DD"))
      }];
      for (var d = currentStartDay.subtract(1, "month"); d.month() !== 2; d.subtract(1, "month")) {
        this.monthList.push({
          month: d.month() + 1,
          period: "from=".concat(d.format("YYYY-MM-DD"), "&to=").concat(d.clone().endOf("month").format("YYYY-MM-DD"))
        });
      }
    },
    // カレンダーの日付が変更されたとき
    changeDate: function changeDate() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data, absenceBySchool;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!_this5.$auth.isAuthenticated) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return Promise.all([getData("attendance_summary?dashboard=1&date=".concat(_this5.selectedDay)), getData("attendance_summary?pieChart=1&date=".concat(_this5.selectedDay, "&school_type=").concat(_this5.activeGrade)), getData("attendance_summary?bar=1&to=".concat(_this5.selectedDay)), getData("attendance_summary?barChartRace=1&date=".concat(_this5.selectedDay))]);
            case 1:
              data = _context4.v;
              absenceBySchool = data[0].items;
              _this5.pieChartData = data[1].items;
              _this5.barData = data[2].items;
              _this5.allBarChartRaceData = _this5.optimizeBarChartRace(data[3].items);
              _this5.allSchools = _this5.mergeSchoolAbsence(absenceBySchool);
              if (_this5.activeGrade === "all") {
                _this5.schools = _this5.allSchools.slice();
                _this5.barChartRaceData = _this5.allBarChartRaceData;
              } else {
                _this5.schools = _this5.allSchools.filter(function (v) {
                  return v.type === _this5.activeGrade;
                });
                _this5.barChartRaceData = _this5.allBarChartRaceData.filter(function (v) {
                  return v.type === _this5.activeGrade;
                });
              }
              _this5.getTotal();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // barグラフの期間変更を行ったとき
    barMonthChange: function barMonthChange() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data, _data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!_this6.$auth.isAuthenticated) {
                _context5.n = 4;
                break;
              }
              if (!(_this6.barMonth === "current")) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return getData("attendance_summary?bar=1&to=".concat(_this6.selectedDay));
            case 1:
              data = _context5.v;
              _this6.barData = data.items;
              _context5.n = 4;
              break;
            case 2:
              _context5.n = 3;
              return getData("attendance_summary?bar=1&".concat(_this6.barMonth));
            case 3:
              _data = _context5.v;
              _this6.barData = _data.items;
            case 4:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};
import { inject } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import TableRow from "@/components/dashboard/TableRow";
import PieChart from "@/components/charts/PieChart";
import Bar from "@/components/charts/Bar";
import PointsMap from "@/components/charts/PointsMap";
import BarChartRace from "@/components/charts/BarChartRace";
import Inc137 from "@/components/common/Inc137";

import { isAuthenticatedKey, meKey, allSchoolListKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'Dashboard',
  setup: function setup(__props, _ref2) {
    var expose = _ref2.expose;
    var isAuthenticated = inject(isAuthenticatedKey);
    var me = inject(meKey);
    var allSchoolList = inject(allSchoolListKey);

    // apiから取得したBarChartRaceのデータを変形する
    var optimizeBarChartRace = function optimizeBarChartRace(itemList) {
      return itemList.map(function (v) {
        var _school$short_name;
        var school = allSchoolList.value.find(function (w) {
          return w.id === v.school_id;
        });
        return _objectSpread(_objectSpread({}, v), {}, {
          name: (_school$short_name = school.short_name) !== null && _school$short_name !== void 0 ? _school$short_name : school.name,
          type: school.type
        });
      });
    };

    // 表と地図用のデータ作成
    var mergeSchoolAbsence = function mergeSchoolAbsence(absenceBySchool) {
      return allSchoolList.value.map(function (v) {
        var school = structuredClone(v);
        var absence = absenceBySchool.find(function (w) {
          return w.school_id === school.id;
        });
        if (absence) {
          school["absence"] = absence;
          school["pointsMap"] = {
            absencePointsMap: absence.absencePointsMap,
            infection: Object.keys(absence).reduce(function (sum, key) {
              return key.match(/感染症/) ? sum + absence[key] : sum;
            }, 0)
          };
        } else {
          // 欠席者がいないとき
          school["absence"] = {
            total: 0
          };
          school["pointsMap"] = {
            absencePointsMap: 0,
            infection: 0
          };
        }
        return school;
      });
    };
    expose({
      allSchoolList: allSchoolList,
      isAuthenticated: isAuthenticated,
      optimizeBarChartRace: optimizeBarChartRace,
      mergeSchoolAbsence: mergeSchoolAbsence
    });
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      me: me,
      allSchoolList: allSchoolList,
      optimizeBarChartRace: optimizeBarChartRace,
      mergeSchoolAbsence: mergeSchoolAbsence,
      TableRow: TableRow,
      PieChart: PieChart,
      Bar: Bar,
      PointsMap: PointsMap,
      BarChartRace: BarChartRace,
      Inc137: Inc137
    };
  }
});